import StaffChatPanel from "@/components/StaffChatPanel";
import ChatRatingsCard from "@/components/admin/ChatRatingsCard";

/**
 * Live-chat tab inside the staff dashboards. Wraps the new full-featured
 * StaffChatPanel which handles password sign-on, FIFO claim queue, admin
 * reassignment, pop-out window, and live-agent presence.
 *
 * Embedded mode keeps the panel inside the dashboard chrome (no min-h-screen)
 * so it slots into the existing tab container. Above the panel we expose the
 * QA ratings card so admins can monitor patient satisfaction without leaving
 * the workflow.
 */
export default function StaffChatTab() {
  return (
    <div className="space-y-4">
      <ChatRatingsCard />
      <div className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 overflow-hidden h-[calc(100vh-340px)] min-h-[500px]">
        <StaffChatPanel embedded={true} />
      </div>
    </div>
  );
}
